@if (!!stickyHeader()) {
  <div class="sticky-header" [ngClass]="stickyFooterClasses()">
    <ng-container [ngTemplateOutlet]="stickyHeader()" />
  </div>
}
<div class=" overflow-container brand-scrollbar {{ removePadding() ? '' : 'pt-2 pt-md-5' }}" [ngClass]="overflowContainerClasses()" #panelScroller>
  <div class="{{ removePadding() ? '' : 'px-2 px-md-5' }}" [ngClass]="contentContainerClasses()">
    <ng-container [ngTemplateOutlet]="mainContent()" />
  </div>
</div>
@if (!!stickyFooter()) {
  <div class="sticky-footer" [ngClass]="stickyFooterClasses()">
    <ng-container [ngTemplateOutlet]="stickyFooter()" />
  </div>
}
